import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לקרוא לפגיעה בשם",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק לטשטש. משהו בי נפגע — ואני מוכן להכיר בזה."
    ],
      [
      "היום אני מפסיק לטשטש. משהו בי נפגע — ואני מוכן להכיר בזה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “אם כואב לי — יש סיבה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “אם כואב לי — יש סיבה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה בדיוק קרה שגרם לאמון שלי להיסדק?",
      "מה הרגש הראשון שעולה בי כשאני נזכר בזה?",
      "מה הכי קשה לי להודות שנפגע בי?"
    ],
      [
      "מה בדיוק קרה שגרם לאמון שלי להיסדק?",
      "מה הרגש הראשון שעולה בי כשאני נזכר בזה?",
      "מה הכי קשה לי להודות שנפגע בי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "היום אני לא מגזים ולא מקטין. אני מכיר בפגיעה."
    ],
      [
      "סגירה",
      "היום אני לא מגזים ולא מקטין. אני מכיר בפגיעה."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום — יד על החזה + נשימה + משפט: “מותר לי להרגיש.”",
      "פעם אחת היום — יד על החזה + נשימה + משפט: “מותר לי להרגיש.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "ההלם והבלבול",
    opening: localizedGenderNode(
      [
      "היום אני נותן מקום לבלבול בלי לדרוש מעצמי סדר."
    ],
      [
      "היום אני נותן מקום לבלבול בלי לדרוש מעצמי סדר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “בלבול הוא תגובה לפגיעה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “בלבול הוא תגובה לפגיעה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה השתנה בי מאז שגיליתי את האמת?",
      "איזה מחשבות חוזרות לי שוב ושוב?",
      "איפה בגוף אני מרגיש את חוסר היציבות?"
    ],
      [
      "מה השתנה בי מאז שגיליתי את האמת?",
      "איזה מחשבות חוזרות לי שוב ושוב?",
      "איפה בגוף אני מרגיש את חוסר היציבות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בלבול לא אומר שאני חלש. הוא אומר שמשהו בי זז."
    ],
      [
      "סגירה",
      "בלבול לא אומר שאני חלש. הוא אומר שמשהו בי זז."
    ]
    ),
    action: localizedGenderNode(
      "10 דקות בלי מסך — רק להיות.",
      "10 דקות בלי מסך — רק להיות."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הסדק באמון",
    opening: localizedGenderNode(
      [
      "היום אני מסתכל על האמון שנשבר, בלי להאשים את עצמי."
    ],
      [
      "היום אני מסתכל על האמון שנשבר, בלי להאשים את עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "על מה סמכתי — ומה נשבר?",
      "מה זה עושה לי כשאני כבר לא בטוח/ה?",
      "איזה חלק בי מנסה להגן על עצמו עכשיו?"
    ],
      [
      "על מה סמכתי — ומה נשבר?",
      "מה זה עושה לי כשאני כבר לא בטוח/ה?",
      "איזה חלק בי מנסה להגן על עצמו עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אמון הוא בסיס. כשבסיס נסדק — הגוף מגיב."
    ],
      [
      "סגירה",
      "אמון הוא בסיס. כשבסיס נסדק — הגוף מגיב."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת שמתארת את הסדק — ולסגור את המחברת.",
      "לכתוב מילה אחת שמתארת את הסדק — ולסגור את המחברת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "שאלות בלי תשובות",
    opening: localizedGenderNode(
      [
      "היום אני פוגש את הצורך לדעת — בלי להישאב."
    ],
      [
      "היום אני פוגש את הצורך לדעת — בלי להישאב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “לא כל שאלה רוצהת מענה היום.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “לא כל שאלה רוצהת מענה היום.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו שאלה רודפת אותי הכי הרבה?",
      "מה אני מקווה שיקרה אם אדע הכול?",
      "איך הגוף שלי מרגיש כשאני מחפש תשובות?"
    ],
      [
      "איזו שאלה רודפת אותי הכי הרבה?",
      "מה אני מקווה שיקרה אם אדע הכול?",
      "איך הגוף שלי מרגיש כשאני מחפש תשובות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לפעמים השקט חשוב יותר מהאמת המלאה."
    ],
      [
      "סגירה",
      "לפעמים השקט חשוב יותר מהאמת המלאה."
    ]
    ),
    action: localizedGenderNode(
      "עצירת 30 שניות לפני כל בדיקה או חקירה.",
      "עצירת 30 שניות לפני כל בדיקה או חקירה."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הכעס",
    opening: localizedGenderNode(
      [
      "היום אני נותן לכעס מקום בלי להרוס."
    ],
      [
      "היום אני נותן לכעס מקום בלי להרוס."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “מותר לי לכעוס.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “מותר לי לכעוס.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "על מה הכעס שלי באמת?",
      "איזה גבול הכעס מנסה להחזיר?",
      "איך אני מוציא כעס בלי לפגוע בעצמי?"
    ],
      [
      "על מה הכעס שלי באמת?",
      "איזה גבול הכעס מנסה להחזיר?",
      "איך אני מוציא כעס בלי לפגוע בעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כעס הוא אנרגיה — לא פסק דין."
    ],
      [
      "סגירה",
      "כעס הוא אנרגיה — לא פסק דין."
    ]
    ),
    action: localizedGenderNode(
      "תנועה של 10 דקות (הליכה/מתיחה).",
      "תנועה של 10 דקות (הליכה/מתיחה)."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "הבושה וההשוואה",
    opening: localizedGenderNode(
      [
      "היום אני מפריד בין פגיעה לבין ערך עצמי."
    ],
      [
      "היום אני מפריד בין פגיעה לבין ערך עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה משפט מביש עולה בי?",
      "למי אני משווה את עצמי?",
      "איזו אמת עדינה קיימת עליי גם עכשיו?"
    ],
      [
      "איזה משפט מביש עולה בי?",
      "למי אני משווה את עצמי?",
      "איזו אמת עדינה קיימת עליי גם עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "פגיעה לא מגדירה מי אני."
    ],
      [
      "סגירה",
      "פגיעה לא מגדירה מי אני."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב תכונה אחת בי שלא נעלמה.",
      "לכתוב תכונה אחת בי שלא נעלמה."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "הגוף זוכר",
    opening: localizedGenderNode(
      [
      "הגוף שלי מספר סיפור — ואני מקשיב."
    ],
      [
      "הגוף שלי מספר סיפור — ואני מקשיב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה איטית."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה איטית."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הגוף מגיב כשאני ליד בן/בת הזוג?",
      "איך הגוף מגיב כשאני לבד?",
      "מה ההבדל ביניהם?"
    ],
      [
      "איך הגוף מגיב כשאני ליד בן/בת הזוג?",
      "איך הגוף מגיב כשאני לבד?",
      "מה ההבדל ביניהם?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הגוף הוא מדד, לא אויב."
    ],
      [
      "סגירה",
      "הגוף הוא מדד, לא אויב."
    ]
    ),
    action: localizedGenderNode(
      "יד על הגוף + נשימה כשעולה טריגר.",
      "יד על הגוף + נשימה כשעולה טריגר."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "פחד מהישנות הפגיעה",
    opening: localizedGenderNode(
      [
      "היום אני מזהה פחד בלי לתת לו לנהל אותי."
    ],
      [
      "היום אני מזהה פחד בלי לתת לו לנהל אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה אני הכי מפחד שיקרה שוב?",
      "מה אני עושה כדי למנוע כאב?",
      "האם זה באמת מגן עליי?"
    ],
      [
      "ממה אני הכי מפחד שיקרה שוב?",
      "מה אני עושה כדי למנוע כאב?",
      "האם זה באמת מגן עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "פחד מנסה לשמור — לפעמים במחיר כבד."
    ],
      [
      "סגירה",
      "פחד מנסה לשמור — לפעמים במחיר כבד."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב פחד אחד ולשים נקודה.",
      "לכתוב פחד אחד ולשים נקודה."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "גבולות",
    opening: localizedGenderNode(
      [
      "היום אני בודק מה אני בוחר/ת כדי להרגיש בטוח."
    ],
      [
      "היום אני בודק מה אני בוחר/ת כדי להרגיש בטוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה גבול חסר לי עכשיו?",
      "מה מפחיד אותי בלשים אותו?",
      "איך גבול נראה בלי איום?"
    ],
      [
      "איזה גבול חסר לי עכשיו?",
      "מה מפחיד אותי בלשים אותו?",
      "איך גבול נראה בלי איום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גבול הוא שמירה על הלב."
    ],
      [
      "סגירה",
      "גבול הוא שמירה על הלב."
    ]
    ),
    action: localizedGenderNode(
      "ניסוח גבול פנימי אחד.",
      "ניסוח גבול פנימי אחד."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "האם אפשר לבנות מחדש",
    opening: localizedGenderNode(
      [
      "היום אני לא מחליט — רק בודק אפשרות."
    ],
      [
      "היום אני לא מחליט — רק בודק אפשרות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הייתי בוחר/ת לראות כדי שאמון יחזור?",
      "מה כבר קרה שמערער אותי?",
      "מה הגוף אומר על האפשרות הזו?"
    ],
      [
      "מה הייתי בוחר/ת לראות כדי שאמון יחזור?",
      "מה כבר קרה שמערער אותי?",
      "מה הגוף אומר על האפשרות הזו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אפשרות אינה התרוצהות."
    ],
      [
      "סגירה",
      "אפשרות אינה התרוצהות."
    ]
    ),
    action: localizedGenderNode(
      "לא לקבל החלטות היום.",
      "לא לקבל החלטות היום."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "האחריות שלי",
    opening: localizedGenderNode(
      [
      "היום אני בודק איפה אני בתוך הסיפור — בלי האשמה."
    ],
      [
      "היום אני בודק איפה אני בתוך הסיפור — בלי האשמה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה כן באחריותי?",
      "מה לא?",
      "איך אחריות נראית בלי ענישה עצמית?"
    ],
      [
      "מה כן באחריותי?",
      "מה לא?",
      "איך אחריות נראית בלי ענישה עצמית?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אחריות לא דורשת כאב."
    ],
      [
      "סגירה",
      "אחריות לא דורשת כאב."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחריות רך לעצמי.",
      "משפט אחריות רך לעצמי."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "מי אני עכשיו",
    opening: localizedGenderNode(
      [
      "היום אני פוגש את עצמי אחרי הפגיעה."
    ],
      [
      "היום אני פוגש את עצמי אחרי הפגיעה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה השתנה בי?",
      "מה התחזק בי למרות הכול?",
      "מה אני בוחר/ת עכשיו יותר מהכול?"
    ],
      [
      "מה השתנה בי?",
      "מה התחזק בי למרות הכול?",
      "מה אני בוחר/ת עכשיו יותר מהכול?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני עדיין כאן."
    ],
      [
      "סגירה",
      "אני עדיין כאן."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמזכירה לי מי אני.",
      "פעולה אחת שמזכירה לי מי אני."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "כיוון קדימה",
    opening: localizedGenderNode(
      [
      "היום אני מסתכל קדימה בעדינות."
    ],
      [
      "היום אני מסתכל קדימה בעדינות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה קשר אני רוצה לחוות בעתיד?",
      "איזה ערך לא אוותר עליו שוב?",
      "מה צעד קטן בכיוון הזה?"
    ],
      [
      "איזה קשר אני רוצה לחוות בעתיד?",
      "איזה ערך לא אוותר עליו שוב?",
      "מה צעד קטן בכיוון הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "עתיד נבנה בצעדים שקטים."
    ],
      [
      "סגירה",
      "עתיד נבנה בצעדים שקטים."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב ערך אחד ולשמור אותו.",
      "לכתוב ערך אחד ולשמור אותו."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה",
    opening: localizedGenderNode(
      [
      "היום אני לא מוחק את מה שהיה — אני בוחר איך להמשיך."
    ],
      [
      "היום אני לא מוחק את מה שהיה — אני בוחר איך להמשיך."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת עמוקה."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת עמוקה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני משחרר כדי להגן על הלב שלי?",
      "מה אני לוקח איתי מהמסע הזה?",
      "משפט חזרה לימים קשים:"
    ],
      [
      "מה אני משחרר כדי להגן על הלב שלי?",
      "מה אני לוקח איתי מהמסע הזה?",
      "משפט חזרה לימים קשים:"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "האמון שלי נפגע — אבל אני לא נעלמתי.",
      "אני לומד להקשיב לעצמי,",
      "ולבחור בקשר שלא דורש ממני להקטין את הלב.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "האמון שלי נפגע — אבל אני לא נעלמתי.",
      "אני לומד להקשיב לעצמי,",
      "ולבחור בקשר שלא דורש ממני להקטין את הלב.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמסמלת נאמנות לעצמי.",
      "פעולה אחת שמסמלת נאמנות לעצמי."
    ),
  },
].map(buildNormalizedDay);

export const lackOfTrustInRelationshipBlueprintHe = buildNormalizedPilotBlueprint({
  id: "lack_of_trust_in_relationship_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "lack_of_trust_in_relationship",
  category: "general",
  journeyName: {
    he: "חוסר אמון בזוגיות (בגידה, שקרים, סודות)",
    en: "Lack of Trust in a Relationship (Betrayal, Lies, Secrets)",
    es: "Falta de confianza en la relación (engaño, mentiras, secretos)",
  },
  days,
});

export default lackOfTrustInRelationshipBlueprintHe;
